module.exports = __webpack_public_path__ + "static/percolation-bc66acc47a89ba3b5505739c37d87f08.gif";